import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchWrapper } from "../_helpers";

// create slice

const name = "MyInvites";
const initialState = createInitialState();
const extraActions = createExtraActions();
const slice = createSlice({
    name,
    initialState,
    extraReducers: (builder) => {
        createExtraReducers(builder, extraActions);
    },
});

// exports

export const MyInvitesActions = { ...slice.actions, ...extraActions };
export const MyInvitesReducer = slice.reducer;

// implementation

function createInitialState() {
    return {
        InviteGridDetails: [],
        InvitePublicCountDetails: [],
        InsertInmateInvitePublicUserResponse: [],
    };
}

function createExtraActions() {
    const baseUrl = `${process.env.REACT_APP_API_URL}`;


    return {
        getInmateInvitePUGrid: getInmateInvitePUGrid(),
        getLoadInmateInvitePublicCount: getLoadInmateInvitePublicCount(),
        InsertInmateInvitePublicUser: InsertInmateInvitePublicUser(),
    };


    function getInmateInvitePUGrid() {
        return createAsyncThunk(
            `${name}/GetInmateInvitePUGrid`,
            async (loginResponse) =>
                await fetchWrapper.post(`${baseUrl}/kiosk/MyInvites/GetInmateInvitePUGrid?inmateId=${loginResponse?.InmateID}&facilityID=${loginResponse?.facilityID}`)
        );
    }
    function getLoadInmateInvitePublicCount() {
        return createAsyncThunk(
            `${name}/getLoadInmateInvitePublicCount`,
            async (loginResponse) =>
                await fetchWrapper.get(`${baseUrl}/kiosk/MyInvites/GetLoadInmateInvitePublicCount?inmateId=${loginResponse?.InmateID}&facilityID=${loginResponse?.facilityID}`) 
        );
    }
    function InsertInmateInvitePublicUser() {
        return createAsyncThunk(
            `${name}/InsertInmateInvitePublicUser`,
            async (objdata) =>
                await fetchWrapper.post(`${baseUrl}/kiosk/MyInvites/InsertInmateInvitePublicUser`, objdata)
        );
    }

}

function createExtraReducers(builder, actions) {
    builder
        .addCase(actions.getInmateInvitePUGrid.pending, (state) => {
            //state.InviteGridDetails = [];
        })
        .addCase(actions.getInmateInvitePUGrid.fulfilled, (state, action) => {
            state.InviteGridDetails = action.payload;
        })
        .addCase(actions.getInmateInvitePUGrid.rejected, (state, action) => {
            state.InviteGridDetails = { error: action.error };
        })
        .addCase(actions.getLoadInmateInvitePublicCount.pending, (state) => {
            state.InvitePublicCountDetails = [];
        })
        .addCase(actions.getLoadInmateInvitePublicCount.fulfilled, (state, action) => {
            state.InvitePublicCountDetails = action.payload;
        })
        .addCase(actions.getLoadInmateInvitePublicCount.rejected, (state, action) => {
            state.InvitePublicCountDetails = { error: action.error };
        })
        .addCase(actions.InsertInmateInvitePublicUser.pending, (state) => {
            state.InsertInmateInvitePublicUserResponse = [];
        })
        .addCase(actions.InsertInmateInvitePublicUser.fulfilled, (state, action) => {
            state.InsertInmateInvitePublicUserResponse = action.payload;
        })
        .addCase(actions.InsertInmateInvitePublicUser.rejected, (state, action) => {
            state.InsertInmateInvitePublicUserResponse = { error: action.error };
        });
}
